import React from 'react';
import { connect } from 'react-redux';
import { AppDispatch } from 'reducers/index';
import { browserHistory } from 'react-router';

import { hideModal } from 'cards/actions/modalActions';

import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import TrashBin from 'assets/images/digitalSaveTheDate/trashbin-circle.svg';
import { toastsActions } from '@zola-helpers/client';
import { deleteOrder } from 'cards/actions/digitalOrdersActions';
import { deleteDraft } from 'cards/actions/digitalDraftsActions';
import {
  deleteDraft as deleteDigitalDraft,
  deletePublished,
} from 'cards/actions/draftsAndOrdersRedesignActions';
import { BUSINESS_UNIT } from '@zola-helpers/client/dist/es/tracking/onboard/onboardTrackingConstants';
import { trackEvent } from '../../../../../util/trackingHelper';

import styles from './styles.module.less';

export type DigitalDeleteConfirmationModalProps = {
  dstdIsPublished: boolean;
  closeModal: () => void;
  onDeleteProjectDraft: (projectUUID: string) => void;
  onDeleteProjectOrder: (projectUUID: string) => void;
  publishedAt: boolean;
  projectUUID: string;
  redirect?: boolean;
};

const DigitalDeleteConfirmationModal = ({
  dstdIsPublished,
  closeModal,
  onDeleteProjectDraft,
  publishedAt,
  projectUUID,
  onDeleteProjectOrder,
  redirect,
}: DigitalDeleteConfirmationModalProps) => {
  const deleteDstd = () => {
    trackEvent('CTA Clicked', {
      business_unit: BUSINESS_UNIT.DIGITAL_SAVE_THE_DATE,
      cta_type: 'BUTTON',
      cta: dstdIsPublished ? 'DELETE_PUBLISHED' : 'DELETE_DRAFT',
    });
    if (publishedAt) {
      onDeleteProjectOrder(projectUUID);
    } else {
      onDeleteProjectDraft(projectUUID);
    }
    if (redirect) {
      browserHistory.push(`/wedding-planning/projects`);
    }
    closeModal();
  };

  const dstdType = dstdIsPublished ? 'published card' : 'draft';

  return (
    <div className={styles.container}>
      <img src={TrashBin} alt="Trash bin" />
      <div className={styles.header}>Delete this {dstdType}?</div>
      <div className={styles.content}>
        <div>We&apos;re just checking. This action can&apos;t be undone!</div>
      </div>
      <div className={styles.buttonContainer}>
        <ButtonV2 onClick={closeModal} variant="secondary">
          No, Keep
        </ButtonV2>
        <ButtonV2 onClick={deleteDstd} className={styles.buttonSpacing}>
          Yes, Delete
        </ButtonV2>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  closeModal: () => dispatch(hideModal()),
  onDeleteProjectDraft: (projectUUID: string) => {
    dispatch(deleteDraft(projectUUID))
      // remove draft from new draftsAndOrdersRedesign section of store
      .then(({ payload }) =>
        dispatch(deleteDigitalDraft(payload.projectUUID, 'DIGITAL', 'SAVE_THE_DATE'))
      )
      .then(() => dispatch(hideModal()))
      .then(() => dispatch(toastsActions.positive({ headline: 'Draft Deleted!' })))
      .catch((error: any) => console.log(error));
  },
  onDeleteProjectOrder: (projectUUID: string) => {
    dispatch(deleteOrder(projectUUID))
      // remove published from new draftsAndOrdersRedesign section of store
      .then(() => dispatch(deletePublished(projectUUID)))
      .then(() => dispatch(hideModal()))
      .then(() => dispatch(toastsActions.positive({ headline: 'Published Card Deleted!' })))
      .catch((error: any) => console.log(error));
  },
  onCancel: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(DigitalDeleteConfirmationModal);
